import { render, staticRenderFns } from "./OtherVendors.vue?vue&type=template&id=1ab10982&"
import script from "./OtherVendors.vue?vue&type=script&lang=js&"
export * from "./OtherVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports